import { Component, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { IS_NOT_NULL_OR_UNDEFINED } from 'cargo-chief-commons';

@Component({
	selector: 'app-base',
	template: ``,
	styleUrls: ['./base.component.scss'],
})
export class BaseComponent implements OnDestroy {
	public isDestroyed$ = new Subject<void>();

	constructor() {}

	setDefaultPageWidth(
		currentPage: string,
		className: string,
		minClientWidth: number,
		containerClass: string = 'full-width-container'
	): void {
		try {
			setTimeout(() => {
				let defaultFullWidthContainer: any = document?.querySelectorAll(`.${containerClass}`)[0];
				if (
					IS_NOT_NULL_OR_UNDEFINED(defaultFullWidthContainer) &&
					IS_NOT_NULL_OR_UNDEFINED(defaultFullWidthContainer.className) &&
					IS_NOT_NULL_OR_UNDEFINED(minClientWidth) &&
					document?.body?.clientWidth < minClientWidth
				) {
					defaultFullWidthContainer.className = `${containerClass} ${className}`;
				}
			}, 600);
		} catch (error) {
			console.error(`Unable to change default width for ${currentPage}`);
		}
	}

	removeMinWidthClass(containerClass: string = 'full-width-container') {
		try {
			setTimeout(() => {
				let defaultFullWidthContainer: any = document?.querySelectorAll(`.${containerClass}`)[0];
				if (
					IS_NOT_NULL_OR_UNDEFINED(defaultFullWidthContainer) &&
					IS_NOT_NULL_OR_UNDEFINED(defaultFullWidthContainer.className)
				) {
					defaultFullWidthContainer.className = `${containerClass}`;
				}
			}, 600);
		} catch (error) {
			console.error(`Unable to remove min width`);
		}
	}

	ngOnDestroy(): void {
		this.isDestroyed$.next();
		this.isDestroyed$.complete();
	}
}
